import React, { useState, useEffect } from "react";

import { styled } from "@mui/material/styles";

import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";

import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import LoadingButton from "@mui/lab/LoadingButton";
import { grey } from "@mui/material/colors";

import { Row } from "components/common";

import TableTitle from "./TableTitle";
import FilterModal from "./FilterModal";
import FilterText from "./FilterText";

import { Container } from "./styles";
import DescriptionAlert from "./DescriptionAlert";

const ColorButton = styled(LoadingButton)(({ theme }) => ({
  color: theme.palette.getContrastText(grey[600]),
  backgroundColor: grey[600],
  "&:hover": {
    backgroundColor: grey[400],
  },
}));

const TableHeader = (props) => {
  const {
    selectedClientId,
    title,
    titleAboveFilterButton = false,
    subTitle,
    loading = false,
    onSearchKeywordChange,
    filters,
    selectedFilters,
    loadingFilterOptions = false,
    hideSaveFilterButtons = false,
    filterModalAutoHeight = false,
    onFilterClick = () => {},
    filterOptionsLoaded,
    onFiltersApplied,
    onFiltersSaved,
    showSearch = true,
    setEqualColSpan = false,
    showDescriptor = false,
    noticeDate = null,
    type = null,
  } = props;

  const [searchKeyword, setSearchKeyword] = useState("");
  const [filterButtonClicked, setFilterButtonClicked] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [selectableFilters, setSelectableFilters] = useState([]);
  const titleDescriptor = type === "leaseEvent" ? "These lease events are filtered based on the alerted notice date." : type === "transaction" ?
  "These transactions are filtered based on the notified due date." : "";
  const datetype =  type === "leaseEvent" ? "Notice date" : type === "transaction" ? "Due date" : "";

  useEffect(() => {
    if(filters){
      setSelectableFilters(filters.filter((f) => !f.hidden));
    }
  }, [filters]);

  useEffect(() => {
    if (!loadingFilterOptions && filterButtonClicked) {
      setFilterModalOpen(true);
      setFilterButtonClicked(false);
    }
  }, [loadingFilterOptions, filterButtonClicked]);

  const handleFiltersApplied = (selectedFilters) => {
    onFiltersApplied(selectedFilters);
  };

  const handleFiltersSaved = (selectedFilters) => {
    onFiltersSaved(selectedFilters);
  };

  const keyPress = (e) => {
    if (e.keyCode === 13) {
      onSearchKeywordChange(searchKeyword);
    }
  };

  const handleFilterClick = () => {
    setFilterButtonClicked(true);
    onFilterClick();
  };

  return (
    <Container>
      {titleAboveFilterButton && (
        <Row style={{ marginBottom: "20px" }}>
          <TableTitle title={title} subTitle={subTitle} />
        </Row>
      )}
      <Row>
        <ColorButton
          className="filter"
          loading={loadingFilterOptions}
          variant="contained"
          startIcon={<FilterListIcon />}
          onClick={handleFilterClick}
        >
          Filters
        </ColorButton>
        <FilterModal
          selectedClientId={selectedClientId}
          open={filterModalOpen}
          filterOptionsLoaded={filterOptionsLoaded}
          onApplyFilter={handleFiltersApplied}
          onSaveFilter={handleFiltersSaved}
          onClose={() => setFilterModalOpen(false)}
          selectedFilters={selectedFilters}
          filters={selectableFilters}
          hideSaveFilterButtons={hideSaveFilterButtons}
          autoHeight={filterModalAutoHeight}
          setEqualColSpan={setEqualColSpan}
          disableSaveApply = {showDescriptor}
        />
      </Row>
      <Row style={{ marginBottom: "20px" }}>
        {!titleAboveFilterButton && (
          <TableTitle title={title} subTitle={subTitle} />
        )}
        {showSearch && (
          <OutlinedInput
            className={`search${titleAboveFilterButton ? " above-filter" : ""}`}
            value={searchKeyword}
            disabled={loading}
            onChange={(event) => setSearchKeyword(event.target.value)}
            onKeyDown={keyPress}
            placeholder="Search here..."
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
          />
        )}
      </Row>
      {showDescriptor && (
        <Row style={{ marginBottom: "20px" }}>
          <DescriptionAlert noticeDate = {noticeDate} dateType = {datetype} titleMessage = {titleDescriptor}></DescriptionAlert>
        </Row>
      )}
      <Row>
        <FilterText
          filters={selectableFilters}
          selectedFilters={selectedFilters}
        />
      </Row>
    </Container>
  );
};

export default TableHeader;
